// Input.js
import React from "react";
import PropTypes from "prop-types";

const Input = ({
  type,
  placeholder,
  value,
  onChange,
  name,
  className,
  style,
  onKeyDown,
  checked,
  disabled = null,
}) => {
  return (
    <input
      name={name}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      autoComplete="off"
      checked={checked}
      className={`${className} input-style`} // Apply the class from theme.scss
      style={{
        ...style,
        height: type === "text" ? "40px" : "auto",
        marginTop: "0",
      }} // Apply inline style
      onKeyDown={onKeyDown}
      disabled={disabled}
    />
  );
};

Input.propTypes = {
  onChange: PropTypes.func,
  name: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object, // Prop for inline styles
};

export default Input;
